export default "__VITE_ASSET__8b85aded__"